export default __webpack_public_path__ + "static/media/Dial_Navy_Aqua.e3ff82f2.png";